import Cookies from "js-cookie";
import React from "react";

export const getCookie = (cookieName: string) => {
  const userToken = Cookies.get(cookieName);

  if (userToken) {
    try {
      const parsedToken = JSON.parse(userToken);
      return parsedToken;
    } catch (error) {
      return userToken;
    }
  }

  return {};
};
export const removeCookie = (cookieName: string) => {
  if (cookieName) {
    Cookies.remove(cookieName, { path: "/" });
  }
};

export const setCookie = (cookieName: string, value: any) => {
  const valueToStore = typeof value == "object" ? JSON.stringify(value) : value;

  Cookies.set(cookieName, valueToStore, { path: "/" });
};
